var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDraw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1727318200001,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 4341,
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M162.105 177.431H80.61c0 45.011 36.484 81.495 81.495 81.495 45.002 0 81.487-36.484 81.487-81.495 0-45.003-36.484-81.487-81.487-81.487-45.011 0-81.495 36.484-81.495 81.487h81.495zM80.61 848.928c0 44.984 36.484 81.479 81.495 81.479 45.002 0 81.487-36.494 81.487-81.479 0-45.018-36.484-81.494-81.487-81.494-45.011 0-81.495 36.476-81.495 81.494zM752.1 177.431c0 45.011 36.475 81.495 81.494 81.495 45.004 0 81.48-36.484 81.48-81.495 0-45.003-36.477-81.487-81.48-81.487-45.02-0.001-81.494 36.484-81.494 81.487z",
    fill: "#000000",
    "p-id": 4342
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M162.105 136.689h671.489v81.487H162.105v-81.487z m0 671.493H439.5v81.496H162.105v-81.496z",
    fill: "#000000",
    "p-id": 4343
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M202.847 177.431v671.497h-81.488V177.431h81.488z m671.497 0v281.81h-81.496V177.416l81.496 0.015zM800.184 527.477l114.842 114.846-235.732 235.85-114.862-114.862 235.752-235.834z m125.728 103.955L811.055 516.631l31.279-31.287c13.527-13.52 35.465-13.52 48.979 0h0.014l65.932 65.931c13.512 13.529 13.527 35.467 0 48.992l-31.277 31.279-0.07-0.114zM513.49 930.457l154.896-41.561-113.425-113.441-41.471 155.002z",
    fill: "#000000",
    "p-id": 4344
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraw);
export default __webpack_public_path__ + "static/media/draw.ccd28e4e9922e6caa8fbcd7ae5553e86.svg";
export { ForwardRef as ReactComponent };